import e from "@dialpad/dialtone-tokens/layered/themes/tokens-aegean-colors.css?inline";
//#region themes/aegean.js
var t = { brand: {
	css: e,
	name: "aegean"
} };
//#endregion
export { t as default };
